import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  initializeAuth,
  indexedDBLocalPersistence,
} from "firebase/auth";
import {
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Same project (fuse-510d6) the native apps use — config comes from .env
// (see .env.example). The web client hits the identical Auth, Firestore,
// callable Functions, and Storage; no backend changes required.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_API_KEY,
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FB_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_SENDER_ID,
  appId: import.meta.env.VITE_FB_APP_ID,
};

export const app = initializeApp(firebaseConfig);

// Auth persists across restarts (IndexedDB first, localStorage fallback) so an
// installed PWA keeps you signed in like a native app.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  // Required for signInWithPopup/Redirect — initializeAuth (unlike getAuth)
  // doesn't bundle the popup/redirect resolver, and Google sign-in throws
  // auth/argument-error without it.
  popupRedirectResolver: browserPopupRedirectResolver,
});

// Firestore offline persistence: cached matches/messages render instantly and
// the app survives flaky mobile connections. Multi-tab safe.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

// Callable functions default to us-central1, matching the deployed functions.
export const functions = getFunctions(app);
export const storage = getStorage(app);
